import React from "react";

const SimToggleSwitch = (props) => {
  const { label = null, ToggleKeyClass, className, toggleKeyNames = null, ...rest } = props;
  return (
    <div class="form-check form-switch sim">
      {label && <label>{label}</label>}
      <div className="toggle-parent">
        <input
          class={` form-check-input ${className} `}
          type="checkbox"
          role="switch"
          id="flexSwitchCheckChecked"
          {...rest}
        />
        {toggleKeyNames && (
          <p class={`${ToggleKeyClass}`} for="flexSwitchCheckChecked">
            {toggleKeyNames}
          </p>
        )}
      </div>
    </div>
  );
};

export default SimToggleSwitch;
